import { graphql } from '@/gql';
import type { UpdateOperatorFaqMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { OperatorFaq } from '@/models/operatorFaq';

export const updateOperatorFaq = async (id: string, data: UpdateOperatorFaqMutationVariables['data']): Promise<OperatorFaq> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation UpdateOperatorFaq($id: String!, $data: OperatorFaqInputType!) {
        updateOperatorFaq(id: $id, data: $data) {
          id
          categories
          answer
          question
          relatedQuestions
          operator {
            firstName
            lastName
          }
          changes {
            id
            user {
              firstName
              lastName
            }
            oldText
            newText
            createdAt
          }
          createdAt
        }
      }
    `),
    variables: {
      id,
      data,
    },
  });

  return response.data?.updateOperatorFaq!;
};
